module.exports = __webpack_public_path__ + "img/pocket_back_height.08172374.png";